export enum ProductType {
  Bike = 'bike',
  Sunbed = 'sunbed',
  Article = 'article',
}
